import {
  CONTENT_ID_ASSETS_LOADED,
  CONTENT_ID_ASSETS_CLEAR,
  CONTENT_ID_ASSET_DETAILS_LOADED,
  CONTENT_ID_ASSET_DETAILS_CLEAR,
  CONTENT_ID_ASSET_MATCH_POLICY_LOADED,
  CONTENT_ID_ASSET_MATCH_POLICY_CLEAR,
  CONTENT_ID_BULK_ASSET_REQUESTS_LOADED,
  CONTENT_ID_BULK_ASSET_REQUESTS_CLEAR,
  CONTENT_ID_BULK_ASSET_REQUEST_STATUS_LOADED,
  CONTENT_ID_BULK_ASSET_REQUEST_STATUS_CLEAR,
} from '../../../actions/actionTypes';

const initialState = {
  assets: null,
  assetDetails: null,
  matchPolicy: null,
  bulkAssetRequests: null,
  bulkAssetRequestStatus: null,
};

const contentIdAssets = (state = initialState, action) => {
  switch (action.type) {
    case CONTENT_ID_ASSETS_LOADED:
      return {
        ...state,
        assets: action.payload.assets,
      };

    case CONTENT_ID_ASSETS_CLEAR:
      return {
        ...state,
        assets: null,
      };

    case CONTENT_ID_ASSET_DETAILS_LOADED:
      return {
        ...state,
        assetDetails: action.payload.assetDetails,
      };

    case CONTENT_ID_ASSET_DETAILS_CLEAR:
      return {
        ...state,
        assetDetails: null,
      };

    case CONTENT_ID_ASSET_MATCH_POLICY_LOADED:
      return {
        ...state,
        matchPolicy: action.payload.matchPolicy,
      };

    case CONTENT_ID_ASSET_MATCH_POLICY_CLEAR:
      return {
        ...state,
        matchPolicy: null,
      };

    case CONTENT_ID_BULK_ASSET_REQUESTS_LOADED:
      return {
        ...state,
        bulkAssetRequests: action.payload.bulkAssetRequests,
      };

    case CONTENT_ID_BULK_ASSET_REQUESTS_CLEAR:
      return {
        ...state,
        bulkAssetRequests: null,
      };

    case CONTENT_ID_BULK_ASSET_REQUEST_STATUS_LOADED:
      return {
        ...state,
        bulkAssetRequestStatus: action.payload.bulkAssetRequestStatus,
      };

    case CONTENT_ID_BULK_ASSET_REQUEST_STATUS_CLEAR:
      return {
        ...state,
        bulkAssetRequestStatus: null,
      };

    default:
      return state;
  }
};

export default contentIdAssets;
